import { ConfigFilterItem } from 'Core/interfaces'

export enum SiteVisitBasicFields {
	id = 'id',
	visitDate = 'visitDate',
	visitParticipants = 'visitParticipants',
	actionNotes = 'actionNotes',
	generalNotes = 'generalNotes',
	supplierContact = 'supplierContact',
	leadAuditor = 'leadAuditor',
	updateDate = 'updateDate',
	supplierLocation = 'supplierLocation',
	communicationType = 'communicationType',
	document = 'document'
}

export enum SiteVisitFilterFields {
	supplierLocationId = 'supplierLocationId'
}

export declare namespace SiteVisit {
	interface Contact {
		firstName: BasicString
		lastName: BasicString
	}

	interface Basic {
		[SiteVisitBasicFields.id]: number
		[SiteVisitBasicFields.visitDate]: BasicString
		[SiteVisitBasicFields.visitParticipants]: BasicString
		[SiteVisitBasicFields.actionNotes]: BasicString
		[SiteVisitBasicFields.generalNotes]: BasicString
		[SiteVisitBasicFields.supplierContact]: Nullable<Contact>
		[SiteVisitBasicFields.leadAuditor]: Nullable<Contact>
		[SiteVisitBasicFields.updateDate]: BasicString
		[SiteVisitBasicFields.supplierLocation]: Nullable<Entity>
		[SiteVisitBasicFields.communicationType]: Nullable<Entity>
		[SiteVisitBasicFields.document]: Nullable<Entity>
	}

	namespace Filter {
		interface Config {
			[SiteVisitFilterFields.supplierLocationId]: ConfigFilterItem<string, string>
		}
	}
}
